import "./GenerativeEngineOptimization.module.css";
import Header from "@/reusable_sections/Header";
import Geoservicesfeatures from "./sections/Geoservicesfeatures";
import Geoimpact from "./sections/Geoimpact";
import Questions from "./sections/Questions";
import Footer from "@/reusable_sections/Footer";
export default function GenerativeEngineOptimizationPage() {
  return <div>
      <Header />
      <Geoservicesfeatures />
      <Geoimpact />
      <Questions />
      <Footer />
    </div>;
}